import { render, staticRenderFns } from "./DidYouMean.vue?vue&type=template&id=0e44f809&scoped=true&"
import script from "./DidYouMean.vue?vue&type=script&lang=js&"
export * from "./DidYouMean.vue?vue&type=script&lang=js&"
import style0 from "./DidYouMean.vue?vue&type=style&index=0&id=0e44f809&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e44f809",
  null
  
)

export default component.exports